export const pagesStorageFilesEn = {
  title: "Storage & Files",
  tabs: {
    folders: "Folders",
    files: "Files",
  },
  provider: {
    box: "Box",
    googleDrive: "Google Drive",
    oneDrive: "OneDrive",
    dropbox: "Dropbox",
  },
  columns: {
    folderName: "Folder name",
    path: "Path",
    confidentialityLevel: "Confidentiality Level",
    users: "User",
    owner: "Owner",
    parentFolder: "Parent Folder",
    fileName: "File name",
    permissionHolders: "Permission Holders",
    lastUpdateTime: "Last Update Time",
  },
  confidentialityLevel: {
    public: "Public",
    internal: "Internal",
    confidential: "Confidential",
    highlyConfidential: "Highly Confidential",
  },
  filter: {
    placeholder: "Search folders",
    filesPlaceholder: "Search files",
  },
};
